import React, { FC, useState } from 'react'
import { createUseStyles } from 'react-jss'
import { DialogsContext } from './dialogs-context'

type DialogsProviderProps = {}

export const DialogsProvider: FC<DialogsProviderProps> = ({
	children,
}) => {

	// hooks
	const [currentDialogs, setCurrentDialogs] = useState<string[]>([])

	return (
		<DialogsContext.Provider value={{
			currentDialogs,
			setCurrentDialogs,
		}}>
			{children}
		</DialogsContext.Provider>
	)
}